t = require('app/scripts/views/internal/teacup-with-helpers')('header_back_menu_button')

module.exports = ->
  t.a '.header-btn.js-back-menu', { href: '/', 'aria-label': t.l('backToHome') }, ->
    t.span '.header-btn-icon.icon-lg.icon-house.light'
